<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="part" id="_idParaDest-3"><a id="_idTextAnchor002"></a>PART ONE </p>
<p class="Normal1 ParaOverride-4"><span class="CharOverride-2">1802–1814</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Storm_in_the_Stars.FINALHC22.vue?593fb328